import { usePageMeta } from '../lib/usePageMeta.js'
import { Button, Section } from '../components/ui.jsx'

export default function NotFound() {
  usePageMeta('Page not found')
  return (
    <Section>
      <div className="mx-auto flex max-w-[520px] flex-col items-center gap-y-5 py-10 text-center">
        <span className="text-[13px] font-bold uppercase tracking-[0.14em] text-primary-dark">404</span>
        <h1 className="text-[36px] font-extrabold leading-[1.1] tracking-[-0.03em] text-ink">
          That page is not on the blueprint.
        </h1>
        <p className="text-[17px] leading-[1.6] text-dim">
          The link may be old or mistyped. Head back home or get in touch and we will point you the right way.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button to="/" icon="arrowRight">
            Back to home
          </Button>
          <Button to="/contact" variant="ghost">
            Contact us
          </Button>
        </div>
      </div>
    </Section>
  )
}
